var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-footer',{staticClass:"layout-footer"},[_c('div',{staticClass:"copyright"},[_vm._v("\n    版权所有 ©\n    "),_c('span',[_vm._v("广州城市可持续发展研究会")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }